import { useMutation } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { format } from 'date-fns';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { IBoeingTableIncreaseHashRate } from '@entities/boeing/IBoeingTableIncreaseHashRate';
import { IIncreaseHashRateFilter } from '@pages/Main/components/IncreaseHashRate/filter';

export interface IIncreaseHashRateList {
  items: IBoeingTableIncreaseHashRate[];
  total_pages: number;
  total_items: number;
  current_page: number;
}

export const fetch = async (filters: IIncreaseHashRateFilter): Promise<IIncreaseHashRateList> => {
  let params = {};

  params = { ...params, page: filters.page, page_size: 5 };

  if (filters.dateFrom) {
    params = {
      ...params,
      date_from: format(new Date(filters.dateFrom), 'yyyy-MM-dd'),
    };
  }

  if (filters.dateTo) {
    params = {
      ...params,
      date_to: format(new Date(filters.dateTo), 'yyyy-MM-dd'),
    };
  }

  if (filters.perPage) {
    params = { ...params, page_size: filters.perPage };
  }

  if (filters.sort) {
    params = {
      ...params,
      sort_order: filters.sort.type,
      sort_by: filters.sort.column,
    };
  }

  const response = await api.get<IIncreaseHashRateList>(`${BI_BASE_URL}/boeing/table/old/clients`, {
    params: {
      managers_ids: filters.managers,
      region: filters.regions,
      source: filters.sources,
      tag: filters.tags,
      page: filters.page,
      coins: filters.coins,
      client_ids: filters.clients,
      accounts: filters.accounts,

      ...params,
    },
  });

  return response.data ?? [];
};

export const useBoeingTableIncreaseHashRates = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: fetch,
    onError: error => errorHandler(error),
  });

  return {
    fetch: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
